import { DesignSystem } from '@/src/design-system'
import { typography } from '@/src/common/theme'
import { View, Text, StyleSheet } from 'react-native'
import { PartnerNetworkRow } from '@/src/experiences/rewards/components/PartnerNetworkRow'
import type { ComponentProps } from 'react'
import { FairmontIcon } from './FairmontIcon'
import { AccorIcon } from './AccorIcon'
import { SofitelIcon } from './SofitelIcon'
import { SlsIcon } from './SlsIcon'
import { MondrianIcon } from './MondrianIcon'
import { RafflesIcon } from './RafflesIcon'

const hotelNetworks = [
  {
    network: <AccorIcon />,
    partners: [<FairmontIcon />, <SofitelIcon />, <SlsIcon />, <MondrianIcon />, <RafflesIcon />],
  },
] as const satisfies ComponentProps<typeof PartnerNetworkRow>[]

export function RewardsComponentsHotelNetworksCard() {
  return (
    <DesignSystem.Card style={styles.container}>
      <View style={styles.section}>
        <Text style={typography['heading/heading5']}>Hotel Networks</Text>
        <Text style={typography['paragraph/sm']}>
          Transfer your Mesa Points to Accor Live Limitless to book luxury stays at hundreds of
          properties
        </Text>
      </View>
      <View style={styles.section}>
        {hotelNetworks.map((props, index) => (
          <PartnerNetworkRow key={index} {...props} />
        ))}
      </View>
      <View style={styles.footer}>
        <Text style={typography['heading/heading5']}>& More...</Text>
      </View>
    </DesignSystem.Card>
  )
}

const styles = StyleSheet.create({
  container: {
    gap: 24,
    paddingTop: 24,
    paddingBottom: 24,
    paddingLeft: 16,
    paddingRight: 16,
  },
  section: {
    gap: 16,
  },
  footer: {
    alignItems: 'center',
  },
})
